import { render, staticRenderFns } from "./PresupuestoCrud.vue?vue&type=template&id=add2c832&"
import script from "./PresupuestoCrud.vue?vue&type=script&lang=js&"
export * from "./PresupuestoCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports